/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import { useOrderDetailContext } from '@euler/app/flows/order/components/OrderDetailProvider';
import { CustomerType } from '@euler/model/enum';
import { memo } from 'react';
import { OrderInfoCell as Cell } from './Cell';
import { OrderInfoSection as Section } from './Section';

export const CustomerInfoSection = memo(() => {
  const { customerType, customerName, customerMobile } =
    useOrderDetailContext();

  return (
    <Section title="客户信息">
      <Cell
        title="客户类型"
        detail={
          customerType === CustomerType.Default
            ? '私家车'
            : customerType === CustomerType.Official
            ? '公务/单位车'
            : '无'
        }
      />
      <Cell title="客户姓名" detail={customerName || '无'} />
      <Cell title="客户电话" detail={customerMobile || '无'} last />
    </Section>
  );
});
